import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';

import PageContainer from 'components/PageContainer';

import { ROUTES } from 'constants/routes';

const MainRouter = (): JSX.Element => (
  <Switch>
    <Route path={['', ROUTES.root]} component={PageContainer} />
  </Switch>
);

export default MainRouter;
